import { isBrowser } from "../utils/index";
const needHoldEvents = ["click"];
const fns = [];

const eventHandle = function (e) {
  fns.forEach(fn => fn(e));
};

needHoldEvents.forEach(function (eventName) {
  if (isBrowser()) {
    document.addEventListener(eventName, eventHandle, true);
  }
});
export default function eventCatch(fn) {
  fns.push(fn);
}